<template>
  <div class="container-fluid mb-6 mb-md-0">
    <router-view :key="$route.path" />
  </div>
</template>

<script>
import { computedGetters } from '@/utils/vuex-helper';

export default {
  name: 'FiflboxNotice',
  data() {
    return {};
  },
  computed: {
    ...computedGetters(['isNoticeMenuVisible'])
  },
  watch: {
    isNoticeMenuVisible: {
      immediate: true,
      handler: function(isAccessAllowed) {
        if (!isAccessAllowed) {
          this.$router.push('/announce/access-block').catch(() => {});
        }
      }
    }
  }
};
</script>

<style lang="scss">
</style>
